import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

// Jds
import {
  Container,
  Notifications,
  ProgressBar,
  Spinner,
  Text,
} from "@jds/core";

// Mui
import { Box } from "@mui/material";

// Local
import useApiHttp from "../../hooks/use-http";
import Header from "./Header/Header";

export default function MainLayout(props) {
  const uploadPhotosStatus = useSelector((state) => state.uploadPhotos);

  let isStarted, uploadCount, totalCount, uploadPercentage;
  isStarted = uploadPhotosStatus.isStarted;
  uploadCount = uploadPhotosStatus.uploadCount;
  totalCount = uploadPhotosStatus.totalCount;
  uploadPercentage = Math.round((uploadCount / totalCount) * 100) || 0;

  return (
    <div className="main__layout" style={{ position: "relative" }}>
      <Header />
      <main>
        <Outlet />
      </main>
      {isStarted && (
        <Box
          width={300}
          sx={{
            position: "fixed",
            padding: "24px ",
            right: "24px",
            bottom: "24px",
            zIndex: 100,
            borderRadius: "16px",
            backgroundColor: "rgba(0, 0, 0, .65)",
          }}
        >
          <ProgressBar
            state={uploadPercentage === 100 ? "success" : "warning"}
            value={uploadCount == totalCount ? 100 : uploadCount / totalCount}
            label={
              <Container>
                {uploadPercentage !== 100 && (
                  <Spinner size="small" kind="inline" />
                )}
                <Text
                  color="white"
                  text={`${
                    uploadPhotosStatus.isDownload ? "Downloaded" : "Uploaded"
                  } ${uploadCount} of ${totalCount}`}
                />
              </Container>
            }
            valueLabel={<Text color="white" text={uploadPercentage + "%"} />}
          />
        </Box>
      )}
    </div>
  );
}
